import {
    AiImageSizeEnum,
    AiPostTypeEnum,
    PostAiGenerationSettingsType,
} from '../../../../../../../../../service/posts/posts-types';

import {AiGenerationSettingsDraftType} from './ai-generation-type';

const GENERATION_CHOICES_COUNT = 3;
const DEFAULT_IMAGE_COUNT = 1;

export function createSettingsDraft(lastSettings: PostAiGenerationSettingsType | null): AiGenerationSettingsDraftType {
    return {
        postType: lastSettings?.postType ?? null,
        userPrompt: lastSettings?.userPrompt ?? '',
        generateImage: lastSettings?.generateImage ?? false,
        imageSize: lastSettings?.imageSize ?? AiImageSizeEnum.square,
        imageCount: lastSettings?.imageCount ?? DEFAULT_IMAGE_COUNT,
    };
}

export function buildGenerationSettings(options: {
    draft: AiGenerationSettingsDraftType;
    postType: AiPostTypeEnum;
    isImageGenerationAvailable: boolean;
}): Omit<PostAiGenerationSettingsType, 'catalogs'> {
    const {draft, postType, isImageGenerationAvailable} = options;

    const userPrompt = draft.userPrompt.trim();
    const isImageRequested = draft.generateImage && isImageGenerationAvailable;

    return {
        postType,
        choicesCount: GENERATION_CHOICES_COUNT,
        generateImage: isImageRequested,
        imageCount: draft.imageCount,
        ...(userPrompt ? {userPrompt} : {}),
        ...(isImageRequested ? {imageSize: draft.imageSize} : {}),
    };
}
